import React, { useState } from 'react';
import { useTranslation } from '../contexts/TranslationContext';

/**
 * ProjectSelector component
 * Handles project selection with URL parameter support and change prevention
 */
function ProjectSelector({
  preSelectedProject,
  projects,
  filteredProjects,
  selectedProject,
  setSelectedProject,
  projectsLoading,
  projectsError,
  loadProjects,
  loading,
  hasUnuploadedFiles,
}) {
  const { t } = useTranslation();
  const [showProjectWarning, setShowProjectWarning] = useState(false);

  if (preSelectedProject) {
    // Single project from URL - show message instead of dropdown
    return (
      <div className="project-message">
        <label>{t('project')} <span className="required">{t('required')}</span>:</label>
        <p className="project-info-message">
          {t('uploadingForProject')} <strong>{preSelectedProject.name}</strong> {t('projectLabel')}
        </p>
      </div>
    );
  }

  // Show dropdown (either all projects or filtered by URL)
  return (
    <>
      <label htmlFor="project-select">{t('selectProject')} <span className="required">{t('required')}</span>:</label>
      {projectsLoading ? (
        <div className="projects-loading">
          <p>{t('loadingProjects')}</p>
        </div>
      ) : projectsError ? (
        <div className="projects-error">
          <p className="error-message">{projectsError}</p>
          <button 
            type="button" 
            onClick={loadProjects}
            className="retry-button"
          >
            {t('retry')}
          </button>
        </div>
      ) : (
        <div 
          className="project-select-wrapper"
          style={{ position: 'relative' }}
          onMouseEnter={() => hasUnuploadedFiles() && setShowProjectWarning(true)}
          onMouseLeave={() => setShowProjectWarning(false)}
        >
          <select
            id="project-select"
            value={selectedProject}
            onChange={(e) => {
              const newProjectId = e.target.value;
              // Prevent project change if there are unuploaded files
              if (hasUnuploadedFiles()) {
                alert(t('cannotChangeProject'));
                // Reset to current project
                e.target.value = selectedProject;
                return;
              }
              setSelectedProject(newProjectId);
            }}
            disabled={loading || hasUnuploadedFiles() || projects.length === 0}
          >
            <option value="">{t('selectProjectOption')}</option>
            {(filteredProjects.length > 0 ? filteredProjects : projects).map(project => (
              <option key={project.id} value={project.id}>
                {project.name}
              </option>
            ))}
          </select>
          {hasUnuploadedFiles() && showProjectWarning && (
            <p 
              className="project-change-warning"
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                marginTop: '4px',
                fontSize: '12px',
                color: '#666',
                backgroundColor: '#fff',
                padding: '4px 8px',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                whiteSpace: 'nowrap',
                zIndex: 10,
                pointerEvents: 'none'
              }}
            >
              {t('cannotChangeProject')}
            </p>
          )}
        </div>
      )}
    </>
  );
}

export default ProjectSelector;

